export default function CountDown (className) {

    let elements  = document.getElementsByClassName(className);
    if(!elements.length) return;

    function pad2(number) {
      var s = String(number);

      while (s.length < 2) {s = "0" + s;}
      return s;
    }

    [].forEach.call(elements, function (el) {

        setInterval(function(){
         
            let rem = Number(el.dataset.timestamp),
            day = Math.floor(rem / 86400),
            hr  = Math.floor((rem % 86400) / 3600),
            min = Math.floor(((rem % 86400) % 3600) / 60),
            sec = ((rem % 86400) % 3600) % 60;
          if (rem < 0) {
            el.innerHTML = "Expired";
          } else {
            el.innerHTML = `<span>${pad2(day)}<span></span></span><span>${pad2(hr)}<span></span></span><span>${pad2(min)}<span></span></span><span>${pad2(sec)}<span></span></span>`;
            
          }
          el.dataset.timestamp = rem-1;
        }, 1000);

    });
}


// WEBPACK FOOTER //
// ./js/src/CountDown.js